import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const Announcements = ({ token, dashData, onRead }) => {
    const announcements = dashData?.all_announcements ?? [];

    // Mark latest as read when this page is visited
    useEffect(() => {
        const markRead = async () => {
            try {
                await fetch('https://menu.searchisend.in/apimenu/v2/v2_dashboard.php?action=mark_read', {
                    method: 'POST',
                    headers: { Authorization: `Bearer ${token}` }
                });
                if (onRead) onRead(); // refresh dash state to clear the dot
            } catch (e) { console.error(e); }
        };
        if (token) markRead();
    }, [token]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div className="admin-card">
            <Link to="/manage_v2_secure_auth/" className="sticky-back-btn">
    <i className="fas fa-arrow-left"></i> Back to Dashboard
</Link>
            <h1 style={{ marginTop: 0 }}>Platform Announcements</h1>
            <p>Here are the latest updates and news from the platform administrators.</p>

            {announcements.length === 0 ? (
                <p style={{ color: 'var(--text-color-secondary)', textAlign: 'center', padding: '40px 0' }}>
                    No active announcements at this time.
                </p>
            ) : (
                <div style={{ marginTop: '20px', display: 'flex', flexDirection: 'column', gap: '20px' }}>
                    {announcements.map(ann => (
                        <div key={ann.id} style={{ backgroundColor: 'var(--bg-color)', border: '1px solid var(--border-color)', borderLeft: '5px solid var(--primary-orange)', padding: '20px', borderRadius: 'var(--border-radius-sm)' }}>
                            <h3 style={{ margin: '0 0 6px 0', color: 'var(--text-color-headings)' }}>{ann.title}</h3>
                            <p style={{ fontSize: '0.9em', color: 'var(--text-color-secondary)', margin: '0 0 12px 0' }}>
                                Posted on: {new Date(ann.created_at).toLocaleDateString('en-IN', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' })}
                            </p>
                            <p style={{ margin: 0, whiteSpace: 'pre-line' }}>{ann.message}</p>
                            {ann.image_url && <img src={ann.image_url} alt="Announcement" style={{ maxWidth: '100%', borderRadius: '8px', marginTop: '12px' }} />}
                            {ann.button_text && ann.button_url && (
                                <a href={ann.button_url} target="_blank" rel="noopener noreferrer" style={{ display: 'inline-block', marginTop: '12px', padding: '10px 20px', backgroundColor: 'var(--primary-orange)', color: '#fff', borderRadius: '50px', fontWeight: '600', textDecoration: 'none' }}>
                                    {ann.button_text}
                                </a>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default Announcements;
